export default {
    driver_performance_case_overview_caseID: "Case ID",
    driver_performance_case_overview_driver: "Driver",
    driver_performance_case_overview_created: "Created",
    driver_performance_case_overview_status: "Status",
    driver_performance_case_overview_coach: "Coach",
    driver_performance_case_overview_completed: "Completed",
    driver_performance_case_overview_nextStep: "Next Step",
    driver_performance_case_overview_tags: "Tags",
    driver_performance_case_overview_overview: "Overview",
    driver_performance_case_overview_risk: "Risk",
    driver_performance_case_overview_improvementPlan: "Improvement Plan",
    driver_performance_case_overview_cases: "Cases",
    driver_performance_case_overview_finish: "Finish",
    driver_performance_case_overview_escalate: "Escalate",
    driver_performance_case_overview_hideDescription: "Hide Description",
    driver_performance_case_overview_showDescription: "Show Description",
}